// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NUWa","placeholdersHeader":"styles_placeholdersHeader__3b21q","editorStyle":"styles_editorStyle__1SVNE","placeholdersBox":"styles_placeholdersBox__1hvKT"};